import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Table, Breadcrumb, ButtonToolbar, Input, Dropdown, MenuItem } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import { SkyLightStateless } from 'react-skylight';
import BusinessUsersModal from './businessUsersModal';
import ReactPaginate from 'react-paginate';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import checkPermission from '../Common/permissions';
import MobileUserTable from '../../containers/Settings/mobileUserTable';
import { 
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isHMM, isOLG, isLMH, isBRO, isSDR, isCRW,
  isSUN, isSC, isSW, isCCW, isRebuild,
} from '../../actions/root_url';

const isAFG = ROOT_API_URL === 'https://afgstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://afg-scm.truckxi.com/api/';
const isHF = ROOT_API_URL === 'https://hfstage-erp.truckxi.com/api/' || ROOT_API_URL === 'https://hf-erp.truckxi.com/api/';
const tableHeight = (window.innerHeight < 930) ? 650 : 650;

class UserManagement extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        currentPage: 0,
        limit: 25,
        limitDisplay: '25',
        searchCustomerNo: '',
        searchFirstName: '',
        searchLastName: '',
        searchEmail: '',
        searchPhone: '',
        users: {
          rows: [],
          selectedRows: null,
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        mobileUsers: [],
        rowClicked: false,
        username: {
          rows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        businessUsersModalOpen: false,
      };
    }

    componentDidMount() {
      document.title = companyCodeTitle;
      setTimeout(() => {
        this.props.fetchBaseUsers();
      }, 1000);
      // this.props.fetchBaseUsers();
      this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchCustomerNo, this.state.searchFirstName, this.state.searchLastName, this.state.searchEmail);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.selectedCompany !== nextProps.selectedCompany) {
        this.props.fetchBaseUsers();
      }
      if (nextProps.users && nextProps.users != this.props.users) {
        const newRows = [...nextProps.users];
        const users = { ...this.state.users, rows: newRows };
        this.setState({ users });
      }
      if (nextProps.mobileUsers !== this.props.mobileUsers) {
        this.setState({ mobileUsers: nextProps.mobileUsers });
      }
      if (nextProps.username !== this.props.username) {
        // As of now, there should only be one row, so no need to map/loop. 
        const rows = [];
        const row = {}
        row.username = nextProps.username;
        rows.push(row);
        this.setState(prevState => ({ 
          username: {
            ...prevState,
            rows: rows,
          }
        }));
      }
    }

    refetchMobileUsers = () => this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchCustomerNo, this.state.searchFirstName, this.state.searchLastName, this.state.searchEmail);

    clickNew(e) {
      e.preventDefault();
      this.props.resetCurrentUser();
      this.context.router.push('/userManagement/new');
    }

    renderTable() {
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.users);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const users = Object.assign({}, this.state.users, { sortColumn, sortDirection });
        this.setState({ users });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.users.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const users = { ...this.state.users, filters: newFilters };
        this.setState({ users });
      };

      // Handle the row select function

      const onRowsSelected = (rows) => {
        const newRows = this.state.users.rows;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        const users = { ...this.state.users, rows: newRows };
        this.setState({ users });
      };

      const onRowsDeselected = (rows) => {
        const newRows = this.state.users.rows;
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        // var rowIndexes = rows.map(r => r.rowIdx);
        const users = { ...this.state.users, rows: newRows };
        this.setState({ users });
      };

      const onRowClick = (rowIdx, row) => {   
        if (rowIdx!=-1 && !this.state.rowClicked && checkPermission('change_baseuser')) {
          this.setState({ rowClicked: true }, () => {
            this.props.resetCurrentUser();
            this.props.selectCurrentUser(row.BaseUser_id);
            this.context.router.push(`/userManagement/${row.BaseUser_id}`);
          });
        }
      };

      // Column difinition

      const columns = [
        {
          key: "username",
          name: <Translate value="user_name" />,
          resizable: true,
          width: 220,
          sortable: true,
          filterable: true,
        },
      ];

      return (        
        <ContentWrapper>
          <Row>
              <div id="UserManagement-dataGrid1">
                <ReactDataGrid
                  rowKey="user_id"
                  onGridSort={handleGridSort}
                  toolbar={<Toolbar enableFilter />}
                  rowHeight={25}
                  onAddFilter={handleFilterChange}
                  columns={columns}
                  width={200}
                  minHeight={tableHeight}
                  rowGetter={rowGetter}
                  rowsCount={getSize()}
                  onRowClick={onRowClick}
                  onRowSelect={onRowsSelected}
                  enableRowSelect="single"
                />
              </div>
          </Row>
          <Row className="total-users">
            <label>
              <Translate value="total_users" />:&nbsp;
                    <span className="font-color-orange">{ this.state.users.rows.length }</span>
            </label>
          </Row>
        </ContentWrapper>
      );
    }

    renderMobileTable() {
      if (this.props.mobileUsersIsLoading && !this.props.mobileUsersError) {
        return <Spinner />;
      }
      const { mobileUsers } = this.state;

      const handleOnPageChange = (data) => {
        this.state.currentPage = data.selected;
        this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchCustomerNo, this.state.searchFirstName, this.state.searchLastName, this.state.searchEmail);
      }

      return (
        <ContentWrapper>
          <Row>
            <Col sm={12}>
              <div>
                <MobileUserTable
                  checkPassword={this.props.checkPassword}
                  checkPasswordSuccess={this.props.checkPasswordSuccess}
                  checkPasswordFailure={this.props.checkPasswordFailure}
                  clearCheckPassword={this.props.clearCheckPassword}
                  rows={mobileUsers}
                  tableHeight={tableHeight}
                  mobileUserId={this.props.mobileUserId}
                  searchCustomerNo={this.state.searchCustomerNo}
                  searchFirstName={this.state.searchFirstName}
                  searchLastName={this.state.searchLastName}
                  searchEmail={this.state.searchEmail}
                  currentPage={this.state.currentPage}
                  limit={this.state.limit}
                  handleShowPriceChange={this.handleShowPriceChange}
                  scmUsers={this.state.users.rows || []}
                  refetchMobileUsers={this.refetchMobileUsers}
                />
              </div>
            </Col>
          </Row>
          <div id="react-pagination">
            <ReactPaginate
              previousLabel={<Translate value="prev_page" />}
              nextLabel={<Translate value="next_page" />}
              containerClassName={'pagination'}
              activeClassName={'active'}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              pageCount={this.props.mobileUsersTotalPages}
              onPageChange={handleOnPageChange}
              forcePage={this.state.currentPage}
            />
          </div>
          <Row className="total-users" style={{ paddingTop: '0px' }}>
            <label>
              <Translate value="total_users" />:&nbsp;
              <span className="font-color-orange">{this.props.mobileUsersTotalCount}</span>
            </label>
          </Row>
        </ContentWrapper>
      );
    }

    renderUsernameTable() {
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.username);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      const handleGridSort = (sortColumn, sortDirection) => {
        const username = Object.assign({}, this.state.username, { sortColumn, sortDirection });
        this.setState({ username });
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.username.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const username = { ...this.state.username, filters: newFilters };
        this.setState({ username });
      };

      const columns = [
        {
          key: "username",
          name: <Translate value="mobile_username" />,
          resizable: true,
          width: 220,
          sortable: true,
          filterable: true,
        },
      ];

      return (
        <ContentWrapper>
          <Row>
            <div id="UserManagement-dataGrid2">
              <ReactDataGrid
                rowKey="username"
                toolbar={<Toolbar enableFilter />}
                rowHeight={25}
                columns={columns}
                onGridSort={handleGridSort}
                onAddFilter={handleFilterChange}
                width={200}
                minHeight={tableHeight}
                rowGetter={rowGetter}
                rowsCount={getSize()}
              />
            </div>
          </Row>
        </ContentWrapper>
      );
    }

    formatMobileUserInfoForExport() {
      const formattedInfo = [];
      const headersRow = ['Customer Number','First Name', 'Last Name', 'Email'];
      formattedInfo.push(headersRow);

      this.state.mobileUsers.forEach((row) => {
        formattedInfo.push([row.CustomerNum, row.FirstName, row.LastName, row.email]);
      });
      return formattedInfo;
    }

    closeBusinessUserModal = () => this.setState({ businessUsersModalOpen: false })
    openBusinessUserModal = () => this.setState({ businessUsersModalOpen: true })

    handleCustomerNoChange = (event) => {
      this.state.searchCustomerNo = event.target.value;
      this.handleTextChange();
    }
    handleFirstNameChange = (event) => {
      this.state.searchFirstName = event.target.value;
      this.handleTextChange();
    }
    handleLastNameChange = (event) => {
      this.state.searchLastName = event.target.value;
      this.handleTextChange();
    }
    handleEmailChange = (event) => {
      this.state.searchEmail = event.target.value;
      this.handleTextChange();
    }

    handlePhoneChange = (event) => {
      this.state.searchPhone = event.target.value;
      this.handleTextChange();
    }
  
    handleOnSubmit = (event) => {
      event.preventDefault();
    }
  
    handleTextChange = () => {
      this.state.currentPage = 0;
      this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchCustomerNo, this.state.searchFirstName, this.state.searchLastName, this.state.searchEmail, this.state.searchPhone);
    }
  
    handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    handleShowPriceChange = () => {
      this.state.currentPage = 0;
      this.props.fetchMobileUsers(this.state.currentPage, this.state.limit, this.state.searchCustomerNo, this.state.searchFirstName, this.state.searchLastName, this.state.searchEmail, this.state.searchPhone);
    }

    render() {
      const limitSelection = [
        {
          label: '25',
          value: 25,
          name: 'limit',
        },
        {
          label: '50',
          value: 50,
          name: 'limit',
        },
        {
          label: '100',
          value: 100,
          name: 'limit',
        },
        {
          label: <Translate value="all" />,
          value: null,
          name: 'limit',
        },
      ]

      const mobileCustomerOrderExportUrl = `${ROOT_URL}v1/customer/export/orders-per-customer?Bearer=${localStorage.getItem('token')}`;
      return (
      //---------------
      // Begin HTML: Create New/Edit user_management
      //---------------
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="admin" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="user_management" />
            </Breadcrumb.Item>
            <ButtonToolbar
              style={{
                zIndex: 1,
                position: 'absolute',
                top: '10px',
                right: '10px',
              }}
            >
            {
              (isAFG || isHMM || isHF || isOLG || isLMH || isBRO || isSDR || isCRW || isSC || isSUN || isSW || isCCW) && <Button
                bsStyle="success"
                className="marginLeftStyle"
                onClick={() => { this.openBusinessUserModal(); }}
              >
                <em className="fa fa-user marginRightStyle" /><Translate value="business_user" />
              </Button>
            }
            </ButtonToolbar>
          </Breadcrumb>
          {/* <div className="content-heading"><Translate value="user_management" /></div> */}
          <Grid id="settings-user-management">
            <Row>
              {!isRebuild &&
              <Col xs={3}>
                <Row>
                  <h1><Translate value="scm_user_info" /></h1>
                </Row>
                <Panel className="position-relative table-collapse-fix">
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="success"
                      className="marginLeftStyle"
                      onClick={(event) => { this.clickNew(event); }}
                      disabled={!checkPermission('add_baseuser')}
                    >
                      <em className="fa fa-plus marginRightStyle" /><Translate value="create_user" />
                    </Button>
                  </ButtonToolbar>
                  { this.renderTable() }
                </Panel>
              </Col>
    }
              <Col xs={isRebuild ? 12 : 9}>
                <h1><Translate value="mobile_user_info" /></h1>
                <Panel className="position-relative table-collapse-fix panel-body-fix">
                  <ButtonToolbar className="table-buttons">
                    <CSVLink
                      data={this.formatMobileUserInfoForExport()}
                      filename={`mobile-user-${moment().format('YYYYMMDD')}.csv`}
                      className="btn btn-success export-to-excel"
                      target="_blank"
                    >
                      <em className="fa fa-download" />
                      <Translate value="mobile_users" />
                    </CSVLink>
                    <Button
                      bsStyle="success"
                      className="export-to-excel"
                      href={mobileCustomerOrderExportUrl}
                      onClick={() => alert(I18n.t('msg_export_order_stats'))}
                    >
                      <em className="fa fa-download" />
                      <Translate value="order_stats" />
                    </Button>
                  </ButtonToolbar>

                  <div className="form-group" style={{ marginBottom: '0px', marginTop: '30px', position: 'absolute', zIndex: 2 }} id="search-product-by">
                    <form onSubmit={this.handleOnSubmit}>
                      <Row>
                        <Col>
                          <label className="col-sm-2"><Translate value="customer_no" /></label>
                          <label className="col-sm-2"><Translate value="first_name" /></label>
                          <label className="col-sm-2"><Translate value="last_name" /></label>
                          <label className="col-sm-2"><Translate value="email" /></label>
                          <label className="col-sm-2"><Translate value="phone" /></label>
                          <label className="col-sm-2"><Translate value="limit" /></label>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="col-sm-2">
                          <Input type="text" onChange={this.handleCustomerNoChange} />
                        </Col>
                        <Col className="col-sm-2">
                          <Input type="text" onChange={this.handleFirstNameChange} />
                        </Col>
                        <Col className="col-sm-2">
                          <Input type="text" onChange={this.handleLastNameChange} />
                        </Col>
                        <Col className="col-sm-2">
                          <Input type="text" onChange={this.handleEmailChange} />
                        </Col>
                        <Col className="col-sm-2">
                          <Input type="text" onChange={this.handlePhoneChange} />
                        </Col>
                        <Col className="col-sm-2">
                          <Dropdown>
                            <Dropdown.Toggle style={{ width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                              {this.state.limitDisplay}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="super-colors">
                              {limitSelection.map(el => {
                                return (
                                  <MenuItem onClick={() => this.handleLimitChange(el)}>{el.label}</MenuItem>
                                )
                              })}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                      </Row>
                    </form>
                  </div>

                  { this.renderMobileTable() }
                </Panel>
              </Col>
              { this.props.username &&
                <Col xs={3}>
                  <h1><Translate value="mobile_username" /></h1>
                  <Panel className="position-relative table-collapse-fix panel-body-fix">
                    { this.renderUsernameTable() }
                  </Panel>
                </Col>
              }
            </Row>
          </Grid>
          <SkyLightStateless
            dialogStyles={{ height: '800px', width: '75%', top: '29%', left: '38%' }}
            isVisible={this.state.businessUsersModalOpen}
            onCloseClicked={this.closeBusinessUserModal}
            title="Business Users"
          >
            <BusinessUsersModal swRefresh={this.refetchMobileUsers}/>
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
}

export default UserManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/userManagement.jsx